import React from 'react';
import Header from '../partials/Header'; 
import Hero from '../content/Hero/Hero';
import Services from '../content/Services/Services';
import Trust from '../content/Trust/Trust';
import Contact from '../content/Contact/Contact';
import { Footer } from '../partials/Footer'; 
import WhatsApp from '../WhatsApp'; 

export const FreelancersScreen = () => {
  
  // DATA NUEVA PARA EL HERO
  const dataHero = {
    subtitulo: "CONTABILIDAD FÁCIL PARA EMPRENDEDORES Y PROFESIONISTAS",
    titulo: "Contabilidad Fácil\npara Emprendedores y\nProfesionistas",
    descripcion: "Te ayudamos con tus impuestos, declaraciones y facturación para que puedas enfocarte en crecer profesionalmente.",
    miniFeatures: [
      "Atención en <br /> todo México",
      "Servicios <br /> 100% en línea",
      "Atención rápida <br /> y personalizada"
    ]
  };

  // DATA NUEVA PARA SECCIÓN BENEFICIOS / ESTADÍSTICAS (Trust)
  const dataTrust = {
  subtitle: "BENEFICIOS",
  title: "Dedica más tiempo a tu trabajo, no a tu contabilidad",
  description: "En Despacho Zwolf hacemos más simple la parte fiscal y contable para profesionistas independientes y personas que trabajan por honorarios.",
  tarjetasNuevas: [
    { id: 1, titulo: "Declaraciones sin complicaciones", desc: "Te ayudamos a mantenerte al día con tus obligaciones fiscales.", esTexto: true },
    { id: 2, titulo: "Facturación Fácil", desc: "Genera tus CFDI de forma práctica y organizada.", esTexto: true },
    { id: 3, titulo: "Atención Personalizada", desc: "Resolvemos tus dudas con atención rápida y cercana.", esTexto: true },
    { id: 4, titulo: "Servicios 100% en Línea", desc: "Gestiona todo desde donde estés, sin vueltas innecesarias.", esTexto: true }
  ]
};

  // DATA NUEVA PARA SECCIÓN SERVICIOS
  const dataServices = {
    subtitle: "SERVICIOS", 
    title: "Servicios Contables para Emprendedores y Profesionistas",
    description: "Adaptamos nuestros servicios según tu actividad profesional y necesidades fiscales.",
    tarjetasNuevas: true // Sigue activa para prender las 4 tarjetas de freelancers
  };

  //  DATA NUEVA PARA EL FORMULARIO DE CONTACTO
  const dataContact = {
    title: "Lleva tu contabilidad de forma más simple y profesional",
    description: "Agenda una asesoría y descubre cómo podemos ayudarte a mantener tus impuestos y facturación en orden.",
    placeholderActividad: "Actividad profesional (ej. diseñador, programador, médico...)",
    textoFinal: "Atención personalizada para emprendedores y profesionistas en todo México."
  };

  return (
    <>
      <Header /> 
      <main>
        <Hero textos={dataHero} />
        <Services datosNuevos={dataServices} />
        <Trust datosNuevos={dataTrust} />
        <Contact datosNuevos={dataContact} />
        <Footer />
        <WhatsApp />
      </main>
    </>
  );
};

